import styled from 'styled-components';
import { CollectionAttributes } from 'utils/types';
import { Box, Flex } from './ui';
import { StringParam, useQueryParam } from 'use-query-params';
import { GalleryView } from '../constants';

interface CollectionFilterProps {
  attribute: CollectionAttributes;
  handleCheck: (name: string, checked: string[]) => void;
  checked: string[];
}

const FilterOptionLabel = styled.label`
  flex-grow: 1;
`;

/**
 * Renders all filterable options for a specific attribute.
 * Eeach option is represented as a checkbox and label pair.
 */
const CollectionFilterOptions = ({ attribute, handleCheck, checked }: CollectionFilterProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [galleryView, setGalleryView] = useQueryParam('view', StringParam);

  const mapAttributeValue = (value: string): string =>
    value === 'true' ? 'Yes' : value === 'false' ? 'No' : value;

  const onCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleCheck(event.target.name, checked);
  };

  return (
    <Flex p={3} wrap>
      {attribute.values.map((item: { name; count }) => (
        <Flex
          width="50%"
          key={item.name}
          alignCenter
          paddingRight={2}
          paddingLeft={2}
          borderRight={
            attribute.values.length > 2 && attribute.values.indexOf(item) % 2 === 0
              ? '1px solid darkgrey'
              : ''
          }
        >
          <input
            id={`check-${attribute.name}-${item.name}`}
            type="checkbox"
            name={`${attribute.name}-${item.name}`}
            checked={checked.indexOf(`${attribute.name}-${item.name}`) !== -1}
            onChange={onCheckChange}
            style={{ margin: '2px 10px 0 0' }}
          />
          <FilterOptionLabel htmlFor={`check-${attribute.name}-${item.name}`}>
            <Flex fontSize="12px" alignCenter justifyBetween={attribute.values.length > 2}>
              <Box mr={2}>{mapAttributeValue(item.name)}</Box>
              {galleryView !== GalleryView.OWNED && <Box>({item.count})</Box>}
            </Flex>
          </FilterOptionLabel>
        </Flex>
      ))}
    </Flex>
  );
};

export default CollectionFilterOptions;
